import { merge } from 'lodash';

import { type AdditionalContentFieldType } from '@core/blocks/edu-flow-2/components/AdditionalContentFields/types';
import { type QuestionType } from '@core/blocks/edu-flow/components/Page/types';
import { type MonarchEditableAsset } from '@core/context/types';
import { type DeepPartial } from '@core/ts/types';

const personalizationQuestionImportantFactors = (
  question: QuestionType,
  {
    questionHeading,
    questionMaximumSelections,
    questionMinimumSelections,
    questionSubHeading,
    questionOptions,
    questionStepId,
    questionStepName,
    sidePanelContentType,
    sidePanelContentValue,
  }: MonarchEditableAsset
): QuestionType => {
  const questionFieldOptions = questionOptions?.map((option) => ({ value: option?.value || option?.label, ...option }));

  const populatedQuestion: DeepPartial<QuestionType> = {
    heading: questionHeading,
    postSubheading: questionSubHeading,
    stepId: questionStepId,
    stepName: questionStepName,
    conditionalContinue: [
      {
        action: 'CONTINUE',
        rules: [
          {
            type: 'MIN',
            field: 'importantFactors',
            value: questionMaximumSelections,
          },
        ],
      },
      {
        action: 'SHOW',
        rules: [
          {
            type: 'MIN',
            field: 'importantFactors',
            value: questionMinimumSelections,
          },
        ],
      },
    ],
    fields: [
      {
        name: 'importantFactors',
        mode: 'incrementCheckbox',
        options: questionFieldOptions,
        max: questionMaximumSelections,
        min: questionMinimumSelections,
      },
    ],
    additionalContent: [
      {
        content: sidePanelContentValue,
        type: sidePanelContentType as AdditionalContentFieldType,
      },
    ],
  };

  return merge(populatedQuestion, question);
};

export default personalizationQuestionImportantFactors;
